import { render, staticRenderFns } from "./ShelveView.vue?vue&type=template&id=7297eb24&"
import script from "./ShelveView.vue?vue&type=script&lang=js&"
export * from "./ShelveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports